
  window.NadosBox = (function () {
    var modal, state = null, flavours = [], ready = false;
    var TRASH = '';
    function el(id) { return document.getElementById(id); }

    function loadFlavours(card) {
      var quelle = (card && card.querySelector && card.querySelector('.nd-sorten')) || document.getElementById('flavour-source');
      flavours = Array.prototype.map.call(quelle ? quelle.querySelectorAll('.flavour-src') : [], function (n) {
        var img = n.querySelector('img');
        var c = parseInt(n.getAttribute('data-cents') || '', 10);
        return { name: n.getAttribute('data-name') || '', src: img ? (img.getAttribute('src') || '') : '',
          variant: n.getAttribute('data-variant') || '', cents: isNaN(c) ? null : c,
          text: n.getAttribute('data-text') || '', icons: (n.getAttribute('data-icons') || '').split(',').filter(Boolean) };
      });
    }
    function sizeOf(card) {
      var s = parseInt(card.getAttribute('data-box-size'), 10);
      if (!s) { var m = /(\d+)/.exec(card.getAttribute('data-name') || ''); s = m ? parseInt(m[1], 10) : 0; }
      return s || 0;
    }
    function euro(cents) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      try { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: cur }); }
      catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac'; }
    }
    function total() { var t = 0; state.counts.forEach(function (n) { t += n; }); return t; }
    function details() {
      var p = [];
      state.counts.forEach(function (n, i) { if (n > 0) p.push(n + '\u00d7 ' + flavours[i].name); });
      return p.join(', ');
    }
    function setBig(i, info) {
      var f = flavours[i];
      if (!f) return;
      // Sorte angeklickt/gehovert: Name und Produktbeschreibung statt Box-Titel
      if (info) { el('box-modal-title').textContent = f.name; el('box-modal-desc').textContent = f.text; }
      el('box-big-img').src = f.src;
      el('box-big-img').alt = f.name;
      var rows = el('flavour-list').children;
      for (var k = 0; k < rows.length; k++) rows[k].classList.toggle('is-active', k === i);
    }
    function refresh() {
      var t = total(), full = t === state.size;
      var c = el('box-counter');
      c.textContent = t + ' / ' + state.size;
      c.classList.toggle('is-full', full);
      var rows = el('flavour-list').children;
      for (var i = 0; i < rows.length; i++) {
        var n = state.counts[i];
        rows[i].classList.toggle('is-selected', n > 0);
        rows[i].querySelector('.q-val').textContent = n;
        rows[i].querySelector('.q-minus').disabled = n === 0;
        rows[i].querySelector('.q-plus').disabled = full || state.fest;
        if (state.fest) rows[i].querySelector('.q-minus').disabled = true;
      }
      el('box-add').disabled = !full;
      el('box-qty-val').textContent = state.qty;
      el('box-qty-minus').disabled = state.qty <= 1;
      if (state.teile) { var sum = 0; state.counts.forEach(function (n, k) { sum += n * (flavours[k].cents || 0); }); state.priceCents = t > 0 ? sum : null; }
      var pr = '';
      if (state.priceCents !== null) pr = '\u00b7 ' + euro(state.priceCents * state.qty);
      el('box-add-price').textContent = pr;
    }
    // Vegan- & Allergen-Icons (Sprite #nd-ic-…, Daten aus den Produkt-Metafeldern)
    var IC_NAMEN = { vegan: ['Vegan', 'Vegan'], glutenfrei: ['Glutenfrei', 'Gluten-free'], gluten: ['Gluten (Weizen)', 'Gluten (wheat)'],
      nuesse: ['Schalenfrüchte (Nüsse)', 'Tree nuts'], erdnuesse: ['Erdnüsse', 'Peanuts'], soja: ['Soja', 'Soy'], sesam: ['Sesam', 'Sesame'], lupine: ['Lupine', 'Lupin'], senf: ['Senf', 'Mustard'] };
    function iconLeiste(ids) {
      var en = window.NadosI18n && NadosI18n.get && NadosI18n.get() === 'en';
      var box = document.createElement('span'); box.className = 'flavour-icons';
      ids.forEach(function (id) {
        if (!IC_NAMEN[id]) return;
        var t = IC_NAMEN[id][en ? 1 : 0];
        box.insertAdjacentHTML('beforeend', '<svg class="nd-ic" role="img" aria-label="' + t + '"><title>' + t + '</title><use href="#nd-ic-' + id + '"/></svg>');
      });
      return box;
    }
    function buildList() {
      var ul = el('flavour-list');
      ul.innerHTML = '';
      flavours.forEach(function (f, i) {
        var li = document.createElement('li');
        li.className = 'flavour-row';
        li.innerHTML = '<img class="flavour-thumb" alt="" src="' + f.src + '">' +
          '<span class="flavour-name"></span>' +
          '<span class="flavour-qty"><button type="button" class="q-minus" aria-label="Weniger">\u2013</button>' +
          '<span class="q-val">0</span><button type="button" class="q-plus" aria-label="Mehr">+</button></span>';
        li.querySelector('.flavour-name').textContent = f.name;
        if (f.icons.length) li.querySelector('.flavour-name').appendChild(iconLeiste(f.icons));
        li.addEventListener('mouseenter', function () { setBig(i, true); });
        li.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('button')) return;
          setBig(i, true);
        });
        li.querySelector('.q-plus').addEventListener('click', function () {
          if (state.fest || total() >= state.size) return;
          state.counts[i] += 1; setBig(i, true); refresh();
        });
        li.querySelector('.q-minus').addEventListener('click', function () {
          if (state.fest || state.counts[i] <= 0) return;
          state.counts[i] -= 1; setBig(i, true); refresh();
        });
        if (state.fest) {
          if (!state.counts[i]) li.hidden = true;
          li.querySelector('.q-minus').disabled = true; li.querySelector('.q-plus').disabled = true;
        }
        ul.appendChild(li);
      });
    }
    // Platz fuer Ueberschrift + Beschreibung: hoechster Text aus Box und allen (sichtbaren) Sorten
    function platzReservieren() {
      if (!state || !modal || modal.hidden) return;
      var t = el('box-modal-title'), d = el('box-modal-desc');
      var tt = t.textContent, dt = d.textContent, ht = 0, hd = 0;
      t.style.minHeight = ''; d.style.minHeight = '';
      var paare = [[state.name, state.card.getAttribute('data-desc') || '']];
      flavours.forEach(function (f, k) { if (!state.fest || state.counts[k] > 0) paare.push([f.name, f.text]); });
      paare.forEach(function (pp) {
        t.textContent = pp[0]; d.textContent = pp[1];
        ht = Math.max(ht, Math.ceil(t.getBoundingClientRect().height)); hd = Math.max(hd, Math.ceil(d.getBoundingClientRect().height));
      });
      t.textContent = tt; d.textContent = dt;
      t.style.minHeight = ht + 'px'; d.style.minHeight = hd + 'px';
    }
    // Donut Cake / Donut Atelier (feste Box mit genau einem Produkt): Fenster wie bei den einzelnen Donuts
    var popScroll = 0;
    function popZeigen(k) {
      var p = el('nd-box-pop'), f = flavours[k];
      buildList(); refresh();
      var tr = function (x) { x = window.NadosT ? NadosT(x) : x; return window.NadosI18n ? window.NadosI18n.t(x) : x; };
      var bild = p.querySelector('[data-pop-bild]');
      bild.src = f.src || state.image; bild.alt = state.name;
      p.querySelector('[data-pop-titel]').textContent = state.name;
      var ziel = p.querySelector('[data-pop-icons]');
      ziel.innerHTML = ''; if (f.icons.length) ziel.appendChild(iconLeiste(f.icons));
      var vorlage = state.card.querySelector('template.nd-pop-vorlage'), pu = p.querySelector('[data-pop-unter]'), pt = p.querySelector('[data-pop-text]');
      var vu = vorlage && vorlage.content ? vorlage.content.querySelector('.nd-pop-unter') : null, va = vorlage && vorlage.content ? vorlage.content.querySelector('.nd-pop-absaetze') : null;
      if (vu || va) {
        pu.textContent = vu ? vu.textContent.trim() : ''; pu.hidden = !pu.textContent;
        pt.innerHTML = va ? va.innerHTML : '';
      } else {
        pu.textContent = ''; pu.hidden = true;
        pt.textContent = f.text || state.card.getAttribute('data-desc') || '';
      }
      p.querySelector('[data-pop-preis]').textContent = state.priceCents !== null ? euro(state.priceCents) : state.priceText;
      p.querySelector('[data-pop-add]').textContent = tr('In den Warenkorb');
      p.querySelector('.nd-sorte-pop-karte').scrollTop = 0;
      popScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
      p.hidden = false;
      document.documentElement.classList.add('box-open');
      var zu = p.querySelector('.nd-sorte-pop-zu');
      if (zu && !(window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches)) { try { zu.focus({ preventScroll: true }); } catch (e) {} }
    }
    function popZu() {
      var p = el('nd-box-pop');
      if (!p || p.hidden) return false;
      p.hidden = true;
      document.documentElement.classList.remove('box-open');
      var y = popScroll;
      var zurueck = function () { if (Math.abs((window.pageYOffset || document.documentElement.scrollTop || 0) - y) > 2) window.scrollTo(0, y); };
      zurueck(); if (window.requestAnimationFrame) requestAnimationFrame(zurueck); setTimeout(zurueck, 60);
      return true;
    }
    function open(card) {
      init();
      loadFlavours(card);
      var cardImg = card.querySelector('.box-card-media img');
      var cents = card.getAttribute('data-price-cents');
      var priceNum = null;
      if (cents !== null && cents !== '') priceNum = parseInt(cents, 10);
      else {
        var t = String(card.getAttribute('data-price') || '').replace(/[^0-9,.\-]/g, '').replace(',', '.');
        var f = parseFloat(t);
        if (!isNaN(f)) priceNum = Math.round(f * 100);
      }
      state = {
        card: card, size: sizeOf(card), name: card.getAttribute('data-name') || '',
        id: card.getAttribute('data-variant-id') || card.getAttribute('data-box-id') || '',
        variant: card.getAttribute('data-variant-id'),
        priceText: card.getAttribute('data-price') || '', priceCents: priceNum,
        image: cardImg ? cardImg.getAttribute('src') : '', qty: 1, counts: flavours.map(function () { return 0; }),
        fest: false, teile: false
      };
      if (!state.variant && flavours.length && flavours.every(function (f) { return f.variant && f.cents !== null; })) state.teile = true;
      // "unsere Wahl": fester Inhalt aus data-inhalt, nur ansehen - nicht aendern
      var inhalt = card.getAttribute('data-inhalt');
      if (inhalt) {
        state.fest = true;
        inhalt.split(',').forEach(function (teil) {
          var m = /^\s*(.+?)\s*:\s*(\d+)\s*$/.exec(teil);
          if (!m) return;
          for (var k = 0; k < flavours.length; k++) {
            if (flavours[k].name === m[1]) { state.counts[k] = parseInt(m[2], 10); break; }
          }
        });
      }
      var einzeln = []; state.counts.forEach(function (n, k) { if (n > 0) einzeln.push(k); });
      if (state.fest && einzeln.length === 1 && el('nd-box-pop')) { popZeigen(einzeln[0]); return; }
      modal.classList.toggle('is-fest', state.fest);
      var tz = el('box-choose-title');
      var tr = function (x) { x = window.NadosT ? NadosT(x) : x; return window.NadosI18n ? window.NadosI18n.t(x) : x; };
      if (tz) tz.textContent = tr(state.fest ? 'Inhalt der Box' : 'Sorten wählen');
      el('box-modal-title').textContent = state.name;
      el('box-modal-desc').textContent = card.getAttribute('data-desc') || '';
      buildList();
      var erste = 0;
      if (state.fest) { for (var q = 0; q < state.counts.length; q++) { if (state.counts[q] > 0) { erste = q; break; } } }
      if (flavours.length) setBig(erste);
      else { el('box-big-img').src = state.image; }
      refresh();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('box-open');
      platzReservieren();
      var cb = modal.querySelector('.box-close');
      if (cb) { try { cb.focus({ preventScroll: true }); } catch (e) {} }
    }
    function close() {
      if (popZu()) { state = null; return; }
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('box-open');
      state = null;
    }
    function addToCart(quelle) {
      if (!state || total() !== state.size || !window.NadosCart) return;
      var d = details(), btn = (quelle && quelle.nodeType === 1) ? quelle : el('box-add');
      window.NadosCart.fly(btn);
      if (state.teile) {
        var teile = [], cents = 0;
        state.counts.forEach(function (n, k) { if (n > 0) { teile.push({ variant: flavours[k].variant, stk: n }); cents += n * (flavours[k].cents || 0); } });
        window.NadosCart.addBox({ id: state.card.getAttribute('data-box-id') || state.id, name: state.name, bild: state.image, cents: cents, details: d,
          qty: state.qty, props: (window.NadosFulfillmentProps ? window.NadosFulfillmentProps() : {}), teile: teile });
      } else if (state.variant) {
        var props = (window.NadosFulfillmentProps ? window.NadosFulfillmentProps() : {});
        props['Sorten'] = d;
        window.NadosCart.addVariant(state.variant, state.qty, props,
          { id: state.id, name: state.name, preis: state.priceText, bild: state.image, details: d });
      } else {
        window.NadosCart.add(state.id, state.name, state.priceText, state.image, d, state.qty);
      }
      close();
    }
    function init() {
      if (ready) return;
      modal = el('box-modal');
      if (!modal) return;
      ready = true;
      loadFlavours();
      Array.prototype.forEach.call(document.querySelectorAll('.box-card-media img'), function (img) {
        if (img.getAttribute('src') || !flavours.length) return;
        var karte = img.closest ? img.closest('.box-card') : null;
        var nr = karte ? parseInt(karte.getAttribute('data-bild') || '0', 10) : 0;
        img.setAttribute('src', (flavours[nr] || flavours[0]).src);
      });
      Array.prototype.forEach.call(modal.querySelectorAll('[data-box-close]'), function (n) { n.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state) close(); });
      var bp = el('nd-box-pop');
      if (bp) {
        bp.addEventListener('click', function (e) {                       // Klick irgendwo schliesst das Fenster
          var b = e.target.closest ? e.target.closest('[data-pop-add]') : null;
          if (b) { e.stopPropagation(); addToCart(b); return; }
          close();
        });
      }
      el('box-add').addEventListener('click', function () { addToCart(); });
      window.addEventListener('resize', function () { if (state) platzReservieren(); });
      // Touch: beim Wischen ueber die Sortenliste wechselt die grosse Vorschau wie beim Hover am Desktop
      var list = el('flavour-list'), lastTouchIdx = -1;
      function vorschauPerTouch(e) {
        var t = e.touches && e.touches[0];
        if (!t) return;
        var n = document.elementFromPoint(t.clientX, t.clientY);
        var row = n && n.closest ? n.closest('.flavour-row') : null;
        if (!row) return;
        var idx = Array.prototype.indexOf.call(list.children, row);
        if (idx > -1 && idx !== lastTouchIdx) { lastTouchIdx = idx; setBig(idx, true); }
      }
      list.addEventListener('touchstart', function (e) { lastTouchIdx = -1; vorschauPerTouch(e); }, { passive: true });
      list.addEventListener('touchmove', vorschauPerTouch, { passive: true });
      el('box-qty-minus').addEventListener('click', function () { if (state && state.qty > 1) { state.qty -= 1; refresh(); } });
      el('box-qty-plus').addEventListener('click', function () { if (state && state.qty < 20) { state.qty += 1; refresh(); } });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    return { open: open, close: close };
  })();
  
